// components/ConfirmDialog.jsx
import { Dialog, DialogTitle, DialogBody, DialogActions } from '../components/dialog';
import { Button } from '../components/button';

export default function ConfirmDialog({ open, onClose, onConfirm, message }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogBody>
        <p className="text-sm text-gray-700 dark:text-white">{message}</p>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>Cancel</Button>
        <Button onClick={() => {
          onConfirm();
          onClose();
        }}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
